import NextSteps from "@garantidos/components/NextSteps"

import If from "@mobi/components/If"

import AccompanyCard from "./components/AccompanyCard"
import FinishedContent from "./components/FinishedContent"
import FinishedMainTitle from "./components/FinishedMainTitle"

import useFinished from "./hooks"

import "./style.scss"

const Finished = () => {
  const { isMobile, proposalIntegrationNumber } = useFinished()

  const blok = {
    title: "Confira aqui quais são os proximos passos:",
    steps: [
      {
        title: "Envio da Proposta",
        text: "",
        status: "done"
      },
      {
        title: "Análise de Crédito",
        text: "Nessa fase podemos solicitar alguns documentos para ajudar na aprovação do valor.",
        status: "ongoing"
      },
      {
        title: "Contato de uma pessoa especialista",
        text: "Nesta fase, disponibilizamos uma pessoa especialista para te auxiliar na contratação. Importante: O contato vai ocorrer por telefone, e-mail ou whatsapp",
        status: "open"
      },
      {
        title: "Formulários",
        text: "Nesta fase, será enviado um formulário para preenchimento de dados complementares.",
        status: "open"
      },
      {
        title: "Análise de documentos e confirmação de dados",
        status: "open"
      },
      {
        title: "Emissão e recebimento de contrato",
        status: "open"
      },
      {
        title: "Liberação do Crédito",
        text: "O valor do empréstimo é creditado em até 3 dias úteis após o retorno do contrato registrado em cartório.",
        status: "open"
      }
    ]
  }

  return (
    <div className="proposalFinished">
      <div className="proposalFinished__header">
        <div className="innerContainer proposalFinished__headerContainer">
          <div className="proposalFinished__contentContainer">
            <FinishedMainTitle
              proposalIntegrationNumber={proposalIntegrationNumber}
            />
          </div>
          <If
            condition={!isMobile}
            renderIf={
              <div className="proposalFinished__cardContainer">
                <AccompanyCard />
              </div>
            }
          />
        </div>
      </div>
      <div className="innerContainer proposalFinished__finishContainer">
        <div className="proposalFinished__contentContainer">
          <NextSteps blok={blok} className="proposalFinished__nextSteps" />
          <FinishedContent />
          <If
            condition={isMobile}
            renderIf={
              <div className="proposalFinished__cardContainer">
                <AccompanyCard />
              </div>
            }
          />
        </div>
      </div>
    </div>
  )
}

export default Finished
